/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVirtualBackgrounds } from 'Redux/modules/webChat/actions';
import { Button, Modal } from 'semantic-ui-react';
import classNames from 'classnames';
import ZoomVideo from '@zoom/videosdk';

import css from './VirtualBackgroundModal.less';

function toDataUrl(url, callback) {
  const xhr = new XMLHttpRequest();
  xhr.onload = function () {
    const reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

export const BackgroundConstants = {
  NONE: 'none',
  BLUR: 'blur',
};

const VisualBackgroundModal = ({ selectedBg, setOpen, setSelectedBg }) => {
  const localVideoTrack = React.useRef(null);
  const localVideoTrackBlur = React.useRef(null);
  const videoRef = React.useRef();
  const canvasRef = React.useRef();
  const [enableVirtual, setEnableVirtual] = useState(false);
  const { virtualBackgrounds } = useSelector(state => state.webChat.video);
  const defaultBg = [BackgroundConstants.NONE, BackgroundConstants.BLUR];
  const backgrounds = [...defaultBg, ...virtualBackgrounds];
  const dispatch = useDispatch();

  const startBlurLocalTrack = image => {
    const options = { imageUrl: image };
    if (!localVideoTrackBlur.current) {
      localVideoTrackBlur.current = ZoomVideo.createLocalVideoTrack();
      localVideoTrackBlur.current?.start(canvasRef.current, options);
    }
  };

  const startNormalLocalTrack = () => {
    if (!localVideoTrack.current) {
      localVideoTrack.current = ZoomVideo.createLocalVideoTrack();
      localVideoTrack.current?.start(videoRef.current);
    }
  };

  const handleChangeBackground = async image => {
    const isBlur = image === BackgroundConstants.BLUR;
    const isImage = image !== BackgroundConstants.BLUR && image !== BackgroundConstants.NONE;
    const modeChanged =
      (selectedBg === BackgroundConstants.NONE && image !== BackgroundConstants.NONE) ||
      (selectedBg !== BackgroundConstants.NONE && image === BackgroundConstants.NONE);
    setEnableVirtual(isBlur);
    if (modeChanged) {
      if (isImage) {
        toDataUrl(image, function (myBase64) {
          startBlurLocalTrack(myBase64);
          localVideoTrackBlur.current?.updateVirtualBackground(myBase64);
        });
      } else if (isBlur) {
        startBlurLocalTrack(image);
        localVideoTrackBlur.current?.updateVirtualBackground(image);
      } else {
        startNormalLocalTrack();
        localVideoTrackBlur.current?.updateVirtualBackground(undefined);
      }
    } else if (isBlur) localVideoTrackBlur.current?.updateVirtualBackground(image);
    else if (isImage)
      toDataUrl(image, function (myBase64) {
        startBlurLocalTrack(myBase64);
        localVideoTrackBlur.current?.updateVirtualBackground(myBase64);
      });
    setSelectedBg(image);
    if (image === BackgroundConstants.NONE) localStorage.removeItem('video-call-background');
    else localStorage.setItem('video-call-background', image);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getVirtualBackgrounds());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (localVideoTrack.current) {
        localVideoTrack.current.stop();
      }
      if (localVideoTrackBlur.current) {
        localVideoTrackBlur.current.stop();
      }
    };
  }, []);

  useEffect(() => {
    const isBlur = selectedBg !== BackgroundConstants.NONE;
    if (isBlur) {
      startBlurLocalTrack(selectedBg);
      setEnableVirtual(true);
    } else {
      startNormalLocalTrack();
    }
  }, [selectedBg]);

  return (
    <Modal onClose={onClose} open style={{ width: '596px' }} closeOnDimmerClick={false}>
      <Modal.Header>Virtual Backgrounds</Modal.Header>
      <Modal.Content>
        <div className={css.content}>
          <div className={css.videoWrap}>
            <canvas
              id="preview-video-call-canvas"
              width="548"
              ref={canvasRef}
              className={classNames({ 'preview-video-show': enableVirtual })}
            />
            <video
              id="preview-video-call"
              width="548"
              ref={videoRef}
              className={classNames({ 'preview-video-show': !enableVirtual })}
            />
          </div>
          <div className={css.wrapBg}>
            {backgrounds.map(item => (
              <div
                key={item}
                onClick={() => handleChangeBackground(item)}
                className={classNames(css.bgItem, { [css.selected]: selectedBg === item })}
                role="button"
                tabIndex="0"
                onKeyUp={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleChangeBackground(item);
                  }
                }}>
                {item === BackgroundConstants.NONE && <div className={css.none}>None</div>}
                {item === BackgroundConstants.BLUR && (
                  <div className={css.blur}>
                    <div
                      className={css.blurBackground}
                      style={{ backgroundImage: `url(${virtualBackgrounds[0]})` }}
                    />
                    <div className={css.blurText}>Blur</div>
                  </div>
                )}
                {item !== BackgroundConstants.NONE && item !== BackgroundConstants.BLUR && (
                  <img src={item} alt="background" />
                )}
              </div>
            ))}
          </div>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          primary
          onClick={() => {
            onClose();
          }}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default VisualBackgroundModal;
